import React from "react";
import { Reveal, Overline, Stagger, StaggerItem } from "./Reveal";
import { CATEGORIES, FLOORS, IMAGES } from "../lib/content";

const CategoryCard = ({ c }) => (
  <StaggerItem className="group relative overflow-hidden bg-ivory border border-black/5">
    <div className="relative h-56 overflow-hidden">
      <img src={c.image} alt={c.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
      <span className="absolute top-4 left-4 font-serif text-2xl text-ivory drop-shadow-lg">{c.index}</span>
    </div>
    <div className="p-7">
      <h4 className="font-serif text-2xl text-navy">{c.name}</h4>
      <p className="mt-1 text-xs uppercase tracking-[0.15em] text-gold-deep">{c.tag}</p>
      <p className="mt-4 text-sm text-navy/60 leading-relaxed">{c.desc}</p>
    </div>
  </StaggerItem>
);

export const KRVMartSection = () => (
  <section data-testid="krvmart-section" className="bg-ivory text-navy py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <Reveal className="max-w-3xl">
        <Overline dark>KRVMart — Retail Ecosystem</Overline>
        <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight">
          KRVMart — Everything for Everyday Living.
        </h2>
        <p className="mt-6 text-lg text-navy/60 leading-relaxed">
          A modern retail ecosystem designed around the way people live, shop, and experience products.
        </p>
      </Reveal>

      <Stagger className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {CATEGORIES.map((c) => <CategoryCard key={c.id} c={c} />)}
      </Stagger>

      {/* Store concept */}
      <div className="mt-28">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <Reveal className="lg:col-span-6 order-2 lg:order-1">
            <Overline dark>Planned Flagship Store Concept</Overline>
            <h3 className="font-serif font-light text-3xl sm:text-5xl tracking-tight">
              A Store Designed Like a Retail Destination
            </h3>
            <p className="mt-6 text-navy/60 leading-relaxed max-w-xl">
              Our planned flagship concept is a three-floor modern retail destination — with clean interiors, organized category zones, wide customer movement, and a premium-yet-accessible, family-oriented shopping experience.
            </p>

            <div className="mt-10 space-y-3">
              {FLOORS.map((f, i) => (
                <StaggerParent key={f.name} index={i} f={f} />
              ))}
            </div>
          </Reveal>

          <Reveal delay={0.15} className="lg:col-span-6 order-1 lg:order-2">
            <div className="overflow-hidden">
              <img src={IMAGES.storeConcept} alt="Planned flagship store concept" className="w-full h-[440px] lg:h-[560px] object-cover" />
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

const StaggerParent = ({ f, index }) => (
  <Reveal delay={0.1 * index} className="flex items-center gap-6 border-t border-black/10 pt-4">
    <span className="font-serif text-4xl text-gold-deep w-16 shrink-0">0{index + 1}</span>
    <div>
      <p className="text-xs uppercase tracking-[0.2em] text-navy/40">{f.level}</p>
      <p className="font-serif text-2xl text-navy">{f.name}</p>
      <p className="text-sm text-navy/55">{f.detail}</p>
    </div>
  </Reveal>
);
